import { isNil } from 'ramda';

import { IApplicationState } from '../../types/redux';
import { IShareFieldRealtorsAndAgencies } from '../../types/redux/shareRealtorsAndAgencies';

export function getPagination(state: IApplicationState) {
  const { tab } = state;
  const { page, limit, total } = (state[tab] as IShareFieldRealtorsAndAgencies).listing;

  if (!isNil(total) && !isNil(limit) && !isNil(page)) {
    return { page, limit, total };
  }

  return null;
}
